import { useCallback, useContext, useReducer } from "react";
import { FRPContext, FRPLocalStorageKey, FRPNotificationActions, FRPNotificationContext, initialNotificationFRPState } from "./FRPState";
import { MitStorage } from "src/managers/MitStorage";


   export function FRPNotification(props: { children: React.ReactElement }) {
      let { state: frpState } = useContext(FRPContext);

      let FRPNotificationReducer = useCallback((state, action: FRPNotificationActions) => {
         function reducer(state: typeof initialNotificationFRPState, action: FRPNotificationActions) {
            if (!frpState.selectedProjectId) {
               return state; // No project selected, do not update notifications
            }
            switch (action.type) {
               case "ViewedElement":
                  return {
                     ...state,
                     [frpState.selectedProjectId]: {
                        ...state[frpState.selectedProjectId],
                        [action.payload]: action.date || new Date()
                     }
                  };
               default:
                  return state;
            }
         };
         let nextState = reducer(state, action);
         MitStorage.setValue(FRPLocalStorageKey, nextState);
         return nextState;
      }, [frpState.selectedProjectId]);
      const [state, dispatch] = useReducer(FRPNotificationReducer, initialNotificationFRPState());

      return (
         <FRPNotificationContext.Provider value={{
             state,
             dispatch
            }}>
            {props.children}
         </FRPNotificationContext.Provider>
      );
   }